<!-- components/cookie-banner/cookie-banner.component.html -->
<div *ngIf="isVisible" class="cookie-banner" [class.show-details]="showDetails">
  <div class="cookie-banner__overlay" (click)="toggleDetails()" *ngIf="showDetails"></div>
  <div class="cookie-banner__content">
    <!-- Visão Geral -->
    <div class="cookie-banner__main d-flex align-items-center justify-content-between col" *ngIf="!showDetails">
      <div class="cookie-banner__content">
        <h3 class="cookie-banner__title">Utilizamos Cookies</h3>
        <p class="cookie-banner__description m-0">
          Nós utilizamos cookies para melhorar sua experiência, analisar tráfego e personalizar conteúdo.
          Ao continuar navegando, você concorda com nossa
          <a [href]="lgpd" class="cookie-banner__link">Política de Privacidade </a>.
        </p>
      </div>
      <div class="col-4">
        <button style="width: 40%;" class="btn btn-primary btn-lg cookie-banner__btn cookie-banner__btn--primary ms-3" (click)="acceptAll()">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>